<template>
  <ul class="list-unstyled" ref="list" v-if="list.length">
    <slot name="before"></slot>
    <template v-if="list.length">
      <template v-for="(task, index) in listForRender">
        <slot name="task" :task="task" :id="id">
          <li :key="task.title">
            <button-social class="social-button" :item="task" />
          </li>
          <li
            v-if="needToCollapse && elementsInRow === index + 2"
            class="show-more"
            @click="showAll()"
            :key="'show-more'"
          >
            <button class="btn-social">
              + {{ list.length - elementsInRow + 1 }} {{ $t('moreTasks') }}
            </button>
          </li>
        </slot>
      </template>
    </template>
  </ul>
</template>

<script>
import ButtonSocial from '@/components/ButtonSocial';

export default {
  props: {
    id: {
      type: String,
      required: true
    },
    list: {
      type: Array,
      required: true
    }
  },

  components: {
    ButtonSocial
  },

  data() {
    return {
      containerWidth: 0,
      elementWidth: 0,
      uncollapsed: false
    };
  },

  computed: {
    needToCollapse() {
      return this.elementsInRow < this.list.length && !this.uncollapsed
        ? true
        : false;
    },
    windowWidth() {
      return this.$root.windowWidth;
    },
    elementsInRow() {
      const count = Math.floor(this.containerWidth / this.elementWidth);
      return count > 1 ? count : 2;
    },
    listForRender() {
      return this.list.map(el => {
        return {
          ...el,
          href: `/campaigns/${this.id}/${el.title.toLowerCase()}`,
          icon: `${el.title.toLowerCase().replace(/\s/g, '')}-round`
        };
      });
    }
  },

  methods: {
    showAll() {
      this.uncollapsed = true;
    },
    updateSizes() {
      if (!this.list.length || !this.$refs.list) return;
      this.containerWidth = this.$refs.list.offsetWidth;
      this.elementWidth = this.$refs.list.firstElementChild.offsetWidth;
    }
  },

  mounted() {
    this.$bus.$on('sidebar:uncollapsed', this.updateSizes.bind(this));
    setTimeout(this.updateSizes.bind(this), 300); // похоже рассинхрон какой-то с анимациями
  },

  beforeDestroy() {
    this.$bus.$off('sidebar:uncollapsed', this.updateSizes);
  },

  watch: {
    windowWidth() {
      this.updateSizes();
    },
    uncollapsed(val) {
      const classList = this.$refs.list.classList;
      val
        ? classList.add('is-uncollapsed')
        : classList.remove('is-uncollapsed');
      return val;
    }
  }
};
</script>

<style lang="scss" scoped>
ul {
  margin-bottom: 0;
}

ul.row {
  display: flex;
  flex-wrap: wrap;
  max-height: 60px;
  overflow: hidden;
  justify-content: space-between;
  margin: 0 -5px;

  &:after {
    content: '';
    flex: auto;
  }

  &.is-uncollapsed {
    overflow: visible;
    max-height: 99999px;
    margin-bottom: -10px;
  }

  .show-more {
    button {
      height: 60px;
      padding: 0 12px;
      border: 1px solid $border-color;
      transition: background-color 0.2s;

      &:hover,
      &:focus {
        background: $lighten-bg;
      }
    }
  }
}

@media only screen and (max-width: 420px) {
  ul.row {
    justify-content: center;
    max-height: 130px;
    margin: 0;

    li {
      width: 100%;

      .social-button {
        width: 100%;
        margin-left: 0;
        margin-right: 0;
      }
    }
  }
}
</style>
